//collection slider
var swiper = new Swiper(".custom-collection-sldier-swiper", {
    slidesPerView:4,
    spaceBetween: 21,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true
    },
    breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                spaceBetween: 20,
                slideToClickedSlide: true,
            },
            // when window width is >= 640px
            775: {
                slidesPerView: 4,
                spaceBetween: 20,
                slideToClickedSlide: true,
            }
          
          }
});


$('.custom-collection-slider .next').click(function(){
  $('.custom-collection-slider .swiper-button-next').trigger('click');
});
$('.custom-collection-slider .prev').click(function(){
  $('.custom-collection-slider .swiper-button-prev').trigger('click');
});


// let divPopText = $('button.product-popup-modal__button').text();
// console.log(divPopText);
if($('button.product-popup-modal__button').text().indexOf("make an enquiry") >= 0){
  console.log('yaaaaaaaaaaaa');
  $(this).addClass('custom-modal-btn');
}


if($('.product-form__buttons').length){
  $('button.product-popup-modal__button').addClass('exist');
}else{
  $('button.product-popup-modal__button').addClass('no-exist');
}

$('.form__label.field__label').removeClass('form__label');


$('.installment').parent('div').addClass('hidden');


$('#Details-menu-drawer-submenu-1').addClass('menu-opening');
$('.menu-opening').attr('open');
$('#Details-menu-drawer-submenu-1').trigger('click');

$('#Details-menu-drawer-submenu-2').addClass('menu-opening');
$('.menu-opening').attr('open');
$('#Details-menu-drawer-submenu-2').trigger('click');




// $(document).ready(function(){
  if ($(window).width() < 990){
    console.log('asdasd');
      let cloneMenu = $('.megamenu-image-item-container').clone();
      let cloneMenu2 = $('.megamenu-image-item-container').clone();

    
      console.log(cloneMenu);
      $('#menu-drawer > div > div > nav > ul').append(cloneMenu2);
      //$('#link-info .menu-drawer__menu').append(cloneMenu);
  }
// });


